import { ApiError } from "../../lib/api";
import { filesSettingsError } from "./mailFiles";
import type { MailMessage } from "./mailTypes";

export const MAIL_STATES: Record<string, string> = {
  evaluating: "判定中", held: "保留", sending: "送出中", handed_off: "リレー受理", partially_failed: "一部失敗",
  failed: "失敗", rejected: "却下", cancelled: "取消", expired: "期限切れ", blocked: "拒否",
  pending: "送出待ち", in_attempt: "試行中", deferred: "一時失敗", unknown: "結果不明", accepted: "リレー受理",
};
export function mailError(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 410) return "本文・添付は削除依頼済み、匿名化済み、または保持期限を過ぎたため閲覧できません (410)";
    if (error.status === 503) return "監査の記録またはスプールに問題があるため表示できません。復旧後に再取得してください (503)";
    if (error.status === 400) { const text = filesSettingsError(error); if (text) return text + " (400)"; }
    if (error.status === 409 && error.message === "not_sent") return "送出前は失効できません(承認前は取消を使ってください) (409)";
    if (error.status === 409) return error.code === "too_old"
      ? "Gmail からもう一度送ってください(改めて判定されます) (409)"
      : error.code === "owner_not_stopped" ? "旧 gateway の停止・終了を確認できません。運用担当者が停止を確認してください (409)"
      : "状態・世代・期限が変わりました。一覧と詳細を再取得してください (409)";
    if (error.status === 403) return "本人の対応付け、権限、または契約を確認してください (403)";
  }
  return error instanceof Error ? error.message : String(error);
}
/** Message-ID が開示された行だけを束ねる。操作は常に uid ごと。 */
export function groupMail(rows: MailMessage[]): { key: string; rows: MailMessage[] }[] {
  const groups = new Map<string, MailMessage[]>();
  for (const row of rows) {
    const key = row.message_id_header ? "message:" + row.message_id_header : "uid:" + row.uid;
    const existing = groups.get(key);
    if (existing) existing.push(row); else groups.set(key, [row]);
  }
  return [...groups].map(([key, rows]) => ({ key, rows }));
}
